import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { EffectsModule } from '@ngrx/effects';
import { StoreModule } from '@ngrx/store';
import { SearchServiceEffects } from './effects';
import { reducer } from './reducer';
import { SearchServiceFacade } from './facade';
import { stateName } from './selectors';

@NgModule({
  imports: [CommonModule, StoreModule.forFeature(stateName, reducer), EffectsModule.forFeature([SearchServiceEffects])],
  exports: [],
  providers: [SearchServiceFacade],
  declarations: [],
})
export class SearchServiceStateModule {}
